import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20colorful%20Korean%20manhwa%20panels%20floating%20in%20space%20with%20warm%20coral%20and%20gold%20tones%2C%20abstract%20geometric%20shapes%2C%20soft%20gradients%2C%20creative%20composition%2C%20vibrant%20but%20not%20overwhelming%2C%20clean%20background%20with%20warm%20cream%20undertones&width=1600&height=900&seq=hero-bg-manhwa&orientation=landscape"
        alt="无遮韩国免费漫画大全 - 免费在线阅读韩漫"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/40 via-foreground-950/25 to-foreground-950/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 max-w-3xl leading-tight">
          无遮韩国免费漫画大全
        </h1>
        <p className="text-base md:text-lg text-background-50/85 mb-8 max-w-2xl leading-relaxed">
          在韩漫漫画网站，您可以找到最全的韩国漫画资源并享受免费在线阅读韩漫。
          网站稳定性高，更新速度快，让您的阅读体验流畅无忧。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-300 cursor-pointer no-underline"
          >
            立即开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm whitespace-nowrap hover:bg-background-50/25 transition-all duration-300 cursor-pointer no-underline"
          >
            了解更多
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">5000+</p>
            <p className="text-xs text-background-50/70 mt-1">漫画资源</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">100万+</p>
            <p className="text-xs text-background-50/70 mt-1">日活跃用户</p>
          </div>
          <div className="w-px h-10 bg-background-50/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-heading font-bold text-background-50">99.9%</p>
            <p className="text-xs text-background-50/70 mt-1">稳定性保障</p>
          </div>
        </div>
      </div>
    </section>
  );
}